export default function($stateProvider) {
    $stateProvider
        .state('dashboard', {
        url: '/dashboard',
        component: 'dashboard'
    });
}



// WEBPACK FOOTER //
// ./app/components/dashboard/states.js